import Cookies from 'js-cookie';
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
import axios from 'axios';
import domReady from '../helpers/dom-ready';
import User from '../features/user-manager';

class Cart {
  constructor() {
    domReady(() => {
      this.userMenu = document.querySelector('.user-menu');
      this.cartItems = [];
      this.hasBeenOpened = false;
      this.currentUser = {};
      this.additionalComments = '';
      this.hasError = false;
      this.hasSentRequest = false;
      this.textAreaOriginalHeight = 52;
      this.textAreaBlurredHeight = 115;

      if (this.userMenu) {
        this.cartButton = this.userMenu.querySelector('.cart-button');
        this.modalWrapper = this.userMenu.querySelector('.modal-wrapper');
        this.cartWrapper = this.modalWrapper.querySelector('.cart');
        this.background = this.userMenu.querySelector('.transparent-background');

        if (this.cartWrapper) {
          this.productsWrapper = this.cartWrapper.querySelector('.products-wrapper');
          this.commentsInput = this.cartWrapper.querySelector('.comments');
          this.clearButton = this.cartWrapper.querySelector('.clear-button');
          this.closeCartButton = this.cartWrapper.querySelector('.close-button');
          this.submitButton = this.cartWrapper.querySelector('.submit-button');
          this.generalErrorMsg = this.cartWrapper.querySelector('.error-message');
          this.successView = this.cartWrapper.querySelector('.success-view');
          this.successButton = this.cartWrapper.querySelector('.success-button');
          this.sendRequestWrapper = this.cartWrapper.querySelector('.send-request-wrapper');

          this.sendRequestApiUrl = this.submitButton.dataset.apiUrl;

          this.updateQuantityBubble();
          this.getUserDetails();
        }

        this.addEventListeners();

        if (this.additionalComments !== '' && this.clearButton.classList.contains('-hidden')) {
          this.clearButton.classList.remove('-hidden');
        }
      }
    });
  }

  addEventListeners() {
    this.cartButton.addEventListener('click', () => {
      this.updateCartView();
    });

    this.closeCartButton.addEventListener('click', () => {
      this.closeCart();
    });

    this.background.addEventListener('click', () => {
      if (this.hasSentRequest) {
        this.resetCart();
      } else {
        this.closeCart();
      }
    });

    this.commentsInput.addEventListener('input', (e) => {
      const { value } = e.target;
      this.additionalComments = value;

      e.target.style.height = `${e.target.scrollHeight}px`;

      if (value !== '' && this.clearButton.classList.contains('-hidden')) {
        this.clearButton.classList.remove('-hidden');
      } else if (value === '' && !this.clearButton.classList.contains('-hidden')) {
        this.clearButton.classList.add('-hidden');
        this.commentsInput.style.height = `${this.textAreaOriginalHeight}px`;
      }
    });

    this.commentsInput.addEventListener('focus', (e) => {
      if (e.target.scrollHeight > this.textAreaBlurredHeight) {
        e.target.style.height = `${e.target.scrollHeight}px`;
      }
    });

    this.commentsInput.addEventListener('blur', (e) => {
      e.preventDefault();
      if (e.target.scrollHeight > this.textAreaBlurredHeight) {
        e.target.style.height = `${this.textAreaBlurredHeight}px`;
      }
    });

    this.clearButton.addEventListener('click', () => {
      this.commentsInput.value = '';
      this.additionalComments = '';
      this.clearButton.classList.add('-hidden');
      this.commentsInput.style.height = `${this.textAreaOriginalHeight}px`;
    });

    this.submitButton.addEventListener('click', (e) => {
      e.preventDefault();
      this.sendRequest();
    });

    this.successButton.addEventListener('click', () => {
      this.resetCart();
    });
  }

  sendRequest() {
    // Bail if no user or products
    if (!this.currentUser || this.cartItems.length < 1) return;

    const formData = new FormData();
    formData.append('user-first-name', this.currentUser.firstName);
    formData.append('user-last-name', this.currentUser.lastName);
    formData.append('user-company', this.currentUser.company);
    formData.append('user-email', this.currentUser.email);
    formData.append('user-address', this.currentUser.address);
    formData.append('user-zipcode', this.currentUser.zipcode);
    formData.append('user-city', this.currentUser.city);
    formData.append('user-country', this.currentUser.country);
    formData.append('additional-comments', this.additionalComments);

    const dbOrderData = [];

    let totalSum = 0;
    this.cartItems.forEach((product, i) => {
      formData.append(`product-name-${i}`, product.title);
      formData.append(`product-link-${i}`, product.link);
      formData.append(`product-quantity-${i}`, product.quantity);
      formData.append(`product-price-${i}`, product.price);
      formData.append(`total-product-price-${i}`, product.price * product.quantity);
      dbOrderData.push({
        title: product.title,
        id: product.productId,
        quantity: product.quantity,
        price: product.price,
      });
      totalSum += product.price * product.quantity;
    });

    formData.append('total-cart-sum', totalSum);
    formData.append('multiple-products', this.cartItems.length);

    const options = {
      headers: { 'content-type': 'multipart/form-data' },
    };

    axios.post(this.sendRequestApiUrl, formData, options)
      .then((response) => {
        if (response.status === 200) {
          User.createOrder(dbOrderData);
          this.showSuccessView();
        } else {
          this.showErrorMessage();
        }
      })
      .catch(() => {
        this.showErrorMessage();
      });
  }

  openCart() {
    disableBodyScroll(this.productsWrapper);

    this.userMenu.classList.add('-open');
    this.userMenu.classList.add('-cart');

    if (this.cartItems.length > 0 && this.sendRequestWrapper.classList.contains('-hidden')) {
      this.sendRequestWrapper.classList.remove('-hidden');
    } else if (this.cartItems.length <= 0 && !this.sendRequestWrapper.classList.contains('-hidden')) {
      this.sendRequestWrapper.classList.add('-hidden');
    }

    if (this.commentsInput.value !== '' && this.commentsInput.scrollHeight > this.textAreaBlurredHeight) {
      this.commentsInput.style.height = `${this.textAreaBlurredHeight}px`;
    } else if (this.commentsInput.value !== '' && this.commentsInput.scrollHeight > this.commentsInput.style.height) {
      this.commentsInput.style.height = 'auto';
    }
  }

  closeCart() {
    enableBodyScroll(this.productsWrapper);

    this.userMenu.classList.remove('-open');
    this.userMenu.classList.remove('-cart');

    if (this.hasError) {
      this.hasError = false;
      this.generalErrorMsg.classList.remove('-visible');
    }
  }

  resetCart() {
    this.successView.classList.add('-hidden');

    this.products.innerHTML = '';
    this.commentsInput.value = '';
    this.quantity.innerText = '';
    this.quantity.classList.add('-hidden');
    this.submitButton.disabled = true;

    this.cartItems = [];
    this.hasBeenOpened = false;
    this.currentUser = {};
    this.additionalComments = '';
    this.hasError = false;
    this.hasSentRequest = false;
    Cookies.remove('quotations-cart');

    this.closeCart();
  }

  showErrorMessage() {
    this.hasError = true;
    this.generalErrorMsg.classList.add('-visible');
  }

  showSuccessView() {
    this.hasSentRequest = true;
    this.successView.classList.remove('-hidden');
  }

  async getUserDetails() {
    const {
      // eslint-disable-next-line camelcase
      first_name, last_name, company, email, address, zipcode, city, country,
    } = await User.getUserDetails();

    this.currentUser = {
      firstName: first_name,
      lastName: last_name,
      company,
      email,
      address,
      zipcode,
      city,
      country,
    };

    const acccountDetails = this.userMenu.querySelector('.cart .account-details');

    const userName = acccountDetails.querySelector('.name');
    // eslint-disable-next-line camelcase
    userName.prepend(`${first_name} ${last_name}`);

    const userEmail = acccountDetails.querySelector('.email');
    const userAddress = acccountDetails.querySelector('.address');
    const userZipcode = acccountDetails.querySelector('.zipcode');

    if (company) {
      userName.append(`${company}`);
    }
    if (email) {
      userEmail.innerText = `${email}`;
    }
    if (address) {
      userAddress.innerText = `${address}`;
    }
    if (zipcode) {
      userZipcode.innerText = `${zipcode}`;
    }
    if (city) {
      userZipcode.innerText += ` ${city},`;
    }
    if (country) {
      userZipcode.innerText += ` ${country}`;
    }
  }

  updateTotalSum() {
    const cookieCartJSON = Cookies.get('quotations-cart');
    const totalSumEl = document.getElementById('send-request-total-sum');
    if (cookieCartJSON) {
      const cookieCart = JSON.parse(cookieCartJSON);
      let sumTotal = 0;
      cookieCart.forEach((item) => {
        sumTotal += item.price * item.quantity;
      });
      if (totalSumEl) {
        const currencyEl = document.getElementById('cart-currency-translation');
        if (currencyEl) {
          const currencyFractionDigits = new Intl.NumberFormat('sv-SE', {
            style: 'currency',
            currency: 'SEK',
          }).resolvedOptions().maximumFractionDigits;

          const displayPrice = (sumTotal).toLocaleString('sv-SE', { maximumFractionDigits: currencyFractionDigits });
          totalSumEl.innerHTML = `${displayPrice} ${currencyEl.value}`;
        } else {
          totalSumEl.innerHTML = sumTotal;
        }
      }
    } else {
      if (!totalSumEl) return;
      totalSumEl.innerHTML = '';
    }
  }

  addProduct(productId, quantity, p) {
    let price;
    // eslint-disable-next-line no-restricted-globals
    if (isNaN(p)) {
      price = 0;
    } else {
      price = p;
    }
    let cookieCart = Cookies.get('quotations-cart');
    if (!cookieCart) {
      // Create new cookie cart ...
      const newCart = [{ productId, quantity, price }];

      Cookies.set('quotations-cart', JSON.stringify(newCart), { sameSite: 'strict' });
    } else {
      // ... or use existing cookie cart
      cookieCart = JSON.parse(cookieCart);
      const currentCookieItem = cookieCart.find(item => item.productId === productId);
      if (currentCookieItem) {
        // Product already in cart
        currentCookieItem.quantity += quantity;
      } else {
        // Add new product to existing cart
        const newCartItem = { productId, quantity, price };

        cookieCart.push(newCartItem);
      }

      // Set session cookie
      Cookies.set('quotations-cart', JSON.stringify(cookieCart), { sameSite: 'strict' });
    }
    this.updateCartView(productId, quantity, price);
  }

  async updateCartView(productId, quantity, price) {
    this.updateQuantityBubble();

    // Populate cart first time user opens it
    if (!this.hasBeenOpened) {
      await this.addCartContent();
      this.hasBeenOpened = true;
    } else if (productId) {
      // Find existing cart item in cart view ...
      const existingCartItem = this.cartItems.find(item => item.productId === productId);
      if (existingCartItem) {
        existingCartItem.quantity += quantity;
        const cartItemElement = this.products.querySelector(`.product[data-id="${productId}"]`);
        cartItemElement.querySelector('input').value = existingCartItem.quantity;
      } else {
        // ... or create new cart item and add it to the view
        await axios.get(`/wp-json/wp/v2/product/${productId}`).then((res) => {
          const newCartItem = {
            productId,
            quantity,
            link: res.data.link,
            title: res.data.title.rendered,
            imgSrc: res.data.featured_img_url,
            price,
          };

          this.createCartItem(newCartItem);

          this.cartItems.push(newCartItem);
        });
      }
    }

    this.updateTotalSum();
    this.openCart();
  }

  async addCartContent() {
    let cookieCart = Cookies.get('quotations-cart');
    if (!cookieCart) return;
    cookieCart = JSON.parse(cookieCart);

    await Promise.all(cookieCart.map(async (product) => {
      await axios.get(`/wp-json/wp/v2/product/${product.productId}`).then((res) => {
        const newCartItem = {
          productId: product.productId,
          quantity: product.quantity,
          link: res.data.link,
          title: res.data.title.rendered,
          imgSrc: res.data.featured_img_url,
          price: product.price,
        };

        this.createCartItem(newCartItem);

        this.cartItems.push(newCartItem);
      });
    }));
  }

  updateQuantityBubble() {
    let cookieCart = Cookies.get('quotations-cart');
    if (!cookieCart) return;
    cookieCart = JSON.parse(cookieCart);

    this.quantity = this.cartButton.querySelector('.quantity');
    let productsCount = 0;

    cookieCart.forEach((item) => {
      productsCount += item.quantity;
    });

    this.quantity.innerText = productsCount;

    if (productsCount > 0 && this.quantity.classList.contains('-hidden')) {
      this.quantity.classList.remove('-hidden');
      this.submitButton.disabled = false;
    }
  }

  async updateProductQuantity(productId, newQuantity) {
    let cookieCart = Cookies.get('quotations-cart');
    if (!cookieCart) return;
    cookieCart = JSON.parse(cookieCart);

    const currentCookieItem = cookieCart.find(item => item.productId === productId);
    currentCookieItem.quantity = newQuantity;

    const existingCartItem = this.cartItems.find(item => item.productId === productId);
    existingCartItem.quantity = newQuantity;
    this.sumEl = document.getElementById(`price-${productId}`);

    // Update the total price after quantity change
    if (this.sumEl) {
      this.sumEl.innerHTML = '';

      const currencyEl = document.getElementById('cart-currency-translation');
      if (currencyEl) {
        const currencyFractionDigits = new Intl.NumberFormat('sv-SE', {
          style: 'currency',
          currency: 'SEK',
        }).resolvedOptions().maximumFractionDigits;

        const displayPrice = (existingCartItem.price * newQuantity).toLocaleString('sv-SE', { maximumFractionDigits: currencyFractionDigits });
        this.sumEl.innerHTML = `${displayPrice} ${currencyEl.value}`;
      } else {
        this.sumEl.innerHTML = existingCartItem.price * newQuantity;
      }
    }

    Cookies.set('quotations-cart', JSON.stringify(cookieCart), { sameSite: 'strict' });

    this.updateTotalSum();
    this.updateQuantityBubble();
  }

  removeProduct(productId, cartItemElement) {
    let cookieCart = Cookies.get('quotations-cart');
    if (!cookieCart) return;
    cookieCart = JSON.parse(cookieCart);

    cartItemElement.remove();

    const updatedCart = cookieCart.filter(item => item.productId !== productId);

    if (updatedCart.length) {
      Cookies.set('quotations-cart', JSON.stringify(updatedCart), { sameSite: 'strict' });
      this.updateQuantityBubble();
    } else {
      Cookies.remove('quotations-cart');
      this.quantity.innerText = '';
      this.quantity.classList.add('-hidden');
      this.submitButton.disabled = true;
    }

    this.cartItems = this.cartItems.filter(item => item.productId !== productId);
    this.updateTotalSum();
  }

  createCartItem(product) {
    const {
      imgSrc, link, title, quantity, productId, price,
    } = product;

    this.products = this.cartWrapper.querySelector('.products');

    const productWrapper = document.createElement('div');
    productWrapper.classList.add('product');
    productWrapper.dataset.id = productId;

    const productLink = document.createElement('a');
    productLink.classList.add('link');
    productLink.href = link;

    const productImage = document.createElement('img');
    productImage.classList.add('image');
    productImage.src = imgSrc;
    productImage.alt = title;
    productLink.appendChild(productImage);

    const infoWrapper = document.createElement('div');
    infoWrapper.classList.add('info-wrapper');

    const productTitle = document.createElement('p');
    productTitle.classList.add('title');
    productTitle.innerHTML = title;

    infoWrapper.appendChild(productTitle);

    const quantityWrapper = document.createElement('div');
    quantityWrapper.classList.add('quantity');

    const minusButton = document.createElement('button');
    minusButton.classList.add('minus');

    const plusButton = document.createElement('button');
    plusButton.classList.add('plus');

    const quantityInput = document.createElement('input');
    quantityInput.classList.add('input');
    quantityInput.type = 'number';
    quantityInput.value = quantity;
    quantityInput.min = 1;
    quantityInput.step = 1;

    minusButton.addEventListener('click', (e) => {
      e.preventDefault();
      if (quantityInput.value > 0) {
        quantityInput.value = parseInt(quantityInput.value, 10) - 1;
        quantityInput.dispatchEvent(new Event('change'));
      }
    });

    plusButton.addEventListener('click', (e) => {
      e.preventDefault();
      quantityInput.value = parseInt(quantityInput.value, 10) + 1;
      quantityInput.dispatchEvent(new Event('change'));
    });

    quantityInput.addEventListener('change', () => {
      if (quantityInput.value > 1) {
        minusButton.disabled = false;
      } else {
        minusButton.disabled = true;
      }
      this.updateProductQuantity(productId, parseInt(quantityInput.value, 10));
    });

    const removeButton = document.createElement('button');
    removeButton.classList.add('remove-button');

    removeButton.addEventListener('click', (e) => {
      e.preventDefault();
      this.removeProduct(productId, productWrapper);
    });

    quantityWrapper.appendChild(minusButton);
    quantityWrapper.appendChild(quantityInput);
    quantityWrapper.appendChild(plusButton);

    const bottomWrapper = document.createElement('div');
    bottomWrapper.classList.add('bottom-wrapper');

    bottomWrapper.appendChild(quantityWrapper);

    if (price) {
      const currencyEl = document.getElementById('cart-currency-translation');
      const priceParagraph = document.createElement('span');
      priceParagraph.classList.add('price');
      const idClass = `price-${productId}`;
      priceParagraph.id = idClass;
      if (currencyEl) {
        const currencyFractionDigits = new Intl.NumberFormat('sv-SE', {
          style: 'currency',
          currency: 'SEK',
        }).resolvedOptions().maximumFractionDigits;

        const displayPrice = (price * quantity).toLocaleString('sv-SE', { maximumFractionDigits: currencyFractionDigits });
        priceParagraph.innerHTML = `${displayPrice} ${currencyEl.value}`;
      } else {
        priceParagraph.innerHTML = price * quantity;
      }

      bottomWrapper.appendChild(priceParagraph);
    }

    infoWrapper.appendChild(bottomWrapper);
    infoWrapper.appendChild(removeButton);

    productWrapper.appendChild(productLink);
    productWrapper.appendChild(infoWrapper);

    this.products.appendChild(productWrapper);
  }
}

const CartInstance = new Cart();
export default CartInstance;
